import React from "react";
import { Redirect, Route } from "react-router-dom";
import { LoggedUserRole } from "../Repository/BaseRepository";
import { User_Roles } from "../Utils/Utils";

export const UserRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (LoggedUserRole !== undefined) {
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Normal_User.trim().toLowerCase() ||
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Super_User.trim().toLowerCase()
          )
            return <Component {...props} />;
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Client_User.trim().toLowerCase()
          )
            return <Redirect to="updatecredentialGrid" />;
          else return <div>You do not have access to this page</div>;
        }
        else {
          return <Redirect to="/" />
        }
      }
      }
    />
  );
};

export const AdminRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (LoggedUserRole !== undefined) {
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Super_User.trim().toLowerCase()
          )
            return <Component {...props} />;

          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Normal_User.trim().toLowerCase()
          )
            return <Redirect to="/dashboard" />;
          if (
            LoggedUserRole.trim().toLowerCase() ===
            User_Roles.Client_User.trim().toLowerCase()
          )
            return <Redirect to="updatecredentialGrid" />;
          else return <div>You do not have access to this page</div>;
        }
        else {
          return <Redirect to="/" />
        }
      }}
    />
  );
};
